import React from 'react';
import { Field, Form } from 'react-final-form';
import Box from '@mui/material/Box';
import RadioGroupAdapter from '../FinalFormAdapters/RadioGroupAdapter';
import { AccountType } from '../../enum/AccountType';
import MfButton from '../UI/Button/MfButton';
import { updateAccountType } from '../../api/user';
import useAccount from '../../hooks/useAccount';

const AccountTypeForm = () => {
  const { fetchAccountResponse } = useAccount();

  const submit = async ({ type }: { type: AccountType }) => {
    try {
      const r = await updateAccountType(type);
      fetchAccountResponse();
      localStorage.setItem('user', JSON.stringify(r));
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Form
      onSubmit={submit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Box sx={{ my: 3 }}>
            <Field
              label="Выберите тип аккаунта"
              name="type"
              component={RadioGroupAdapter}
              items={[
                {
                  value: AccountType.PERSON,
                  label: 'ФЛ',
                },
                {
                  value: AccountType.IP,
                  label: 'ИП',
                },
                {
                  value: AccountType.LEGAL,
                  label: 'ЮЛ',
                },
              ]}
            />
          </Box>
          <MfButton type="submit" variant="contained">
            Далее
          </MfButton>
        </form>
      )}
    />
  );
};

export default AccountTypeForm;
